import React, { useEffect, useState } from "react";
import { fetchReportGoals } from "../../../services/httpClient";
import { formatDateTimeToLocal } from "../../../helpers/date";
import DataTable from "../ui/DataTable";

interface CasesCompletingGoalsTableState {
  data?: any[];
  startDate?: string;
  endDate?: string;
  useDatePicker?: boolean;
}

export const CasesCompletingGoalsTable = ({ data, startDate, endDate, useDatePicker = false }: CasesCompletingGoalsTableState) => {
  const [casesCompletingGoals, setCasesCompletingGoals] = useState<any[]>();

  const tableHeaders = [
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case Name", key: "case_name" },
    { label: "Goals Completed", key: "goals_completed" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (data || data === 0) {
        setCasesCompletingGoals(data);
      } else {
        //default dates
        const starting = new Date();
        starting.setDate(starting.getDate() - 365);
        var start = starting.toISOString().slice(0, 10);
        var end = new Date().toISOString().slice(0, 10);
        if (useDatePicker) {
          start = startDate ?? start;
          end = endDate ?? end;
        }
        const completingGoals = await getGoals(start!, end!);
        setCasesCompletingGoals(completingGoals);
      }
    };

    fetchData();
  }, [data, startDate, endDate]);

  const getGoals = async (start: string, end: string): Promise<any[]> => {
    try {
      const res = await fetchReportGoals(start, end);
      const goals = res[0]?.data;
      const sortedGoals = goals.sort((a: any, b: any) => (a.completed_at < b.completed_at ? 1 : -1));
      sortedGoals.forEach((goal: any) => {
        if (goal?.completed_at) {
          const localDateTime = formatDateTimeToLocal(goal.completed_at);
          goal.completed_at_formatted = localDateTime.date + " " + localDateTime.time;
        }
        if (goal?.created_at) {
          const localDateTime = formatDateTimeToLocal(goal.created_at);
          goal.created_at_formatted = localDateTime.date + " " + localDateTime.time;
        }
      });

      const completingCases = uniqueCasesWithCompletedGoals(sortedGoals);
      setCasesCompletingGoals(completingCases);
      return completingCases;
    } catch (err: any) {
      console.log(err);
      return [];
    }
  };

  const uniqueCasesWithCompletedGoals = (sortedGoals: any[]) =>
    Object.values(
      sortedGoals
        .filter((g: any) => g.completed_at)
        .reduce((acc: any, g: any) => {
          if (acc[g.case_id]) {
            acc[g.case_id].goals_completed++;
          } else {
            acc[g.case_id] = { case_id: g.case_id, case_name: g.case_name, goals_completed: 1 };
          }
          return acc;
        }, {}),
    );

  return casesCompletingGoals && casesCompletingGoals.length > 0 ? (
    <DataTable tableHeadings={tableHeaders} tableData={casesCompletingGoals} title={"Cases Completing Goals"} />
  ) : (
    <p>No Cases Completing Goals Records</p>
  );
};
